import React from "react";

const Avatar = ({ src, alt, size, name }) => {
  let firstName = "",
    lastName = "";
  if (name) {
    const nameParts = name.split(" ");
    firstName = nameParts[0] || "";
    lastName = nameParts[1] || "";
  }

  const avatarSizeClass = `w-${size} h-${size}`;
  let avatarContent;

  if (src) {
    avatarContent = (
      <img src={src} alt={alt} className={`rounded-full ${avatarSizeClass}`} />
    );
  } else if (name) {
    const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;
    avatarContent = (
      <div
        className={`rounded-full p-1 ${avatarSizeClass} bg-gray-300 flex items-center justify-center text-gray-500 font-bold`}
      >
        {initials.toUpperCase()}
      </div>
    );
  } else {
    avatarContent = (
      <div
        className={`rounded-full p-1 ${avatarSizeClass} bg-gray-300 flex items-center justify-center text-gray-500 font-bold`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 50"
          className={`h-6 w-6 ${avatarSizeClass}`}
          fill="currentColor"
        >
          <path d="M25,1C11.767,1,1,11.767,1,25c0,7.091,3.094,13.472,8,17.869v0.017l0.348,0.3c0.061,0.053,0.128,0.097,0.19,0.149 c0.431,0.364,0.875,0.713,1.331,1.047c0.123,0.09,0.246,0.177,0.371,0.264c0.484,0.34,0.979,0.664,1.487,0.968 c0.085,0.051,0.172,0.099,0.257,0.148c0.557,0.324,1.126,0.629,1.71,0.908c0.006,0.003,0.012,0.005,0.018,0.008 c1.249,0.595,2.559,1.082,3.915,1.456c0.025,0.007,0.05,0.015,0.075,0.021c0.641,0.175,1.293,0.322,1.954,0.443 c0.062,0.011,0.123,0.022,0.185,0.033c0.638,0.112,1.284,0.201,1.939,0.262c0.075,0.007,0.15,0.011,0.224,0.017 C23.663,48.965,24.327,49,25,49s1.337-0.035,1.996-0.09c0.075-0.006,0.15-0.01,0.224-0.017c0.655-0.06,1.301-0.15,1.939-0.262 c0.062-0.011,0.123-0.022,0.185-0.033c0.661-0.121,1.313-0.268,1.954-0.443c0.025-0.007,0.05-0.014,0.075-0.021 c1.356-0.374,2.666-0.861,3.915-1.456c0.006-0.003,0.012-0.005,0.018-0.008c0.584-0.279,1.153-0.585,1.71-0.908 c0.086-0.05,0.172-0.097,0.257-0.148c0.509-0.304,1.004-0.629,1.487-0.968c0.124-0.087,0.248-0.174,0.371-0.264 c0.456-0.334,0.9-0.683,1.331-1.047c0.062-0.052,0.129-0.096,0.19-0.149l0.348-0.3v-0.017 c4.906-4.398,8-10.778,8-17.869C49,11.767,38.233,1,25,1z M25,25c-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8S29.411,25,25,25z M28,27c6.065,0,11,4.935,11,11v3.958c-0.042,0.035-0.086,0.067-0.128,0.102c-0.395,0.321-0.8,0.626-1.214,0.918 c-0.092,0.065-0.182,0.132-0.274,0.195c-0.447,0.305-0.906,0.591-1.373,0.862c-0.085,0.05-0.171,0.099-0.257,0.148 c-0.49,0.275-0.989,0.533-1.498,0.769c-0.053,0.025-0.107,0.049-0.161,0.073c-1.661,0.755-3.411,1.302-5.212,1.626 c-0.057,0.01-0.114,0.021-0.171,0.031c-0.567,0.097-1.139,0.172-1.715,0.225c-0.079,0.007-0.159,0.012-0.239,0.018 C26.175,46.97,25.589,47,25,47s-1.175-0.03-1.758-0.077c-0.079-0.006-0.159-0.011-0.239-0.018 c-0.576-0.053-1.148-0.127-1.715-0.225c-0.057-0.01-0.114-0.02-0.171-0.031c-1.801-0.324-3.551-0.871-5.212-1.626 c-0.054-0.025-0.108-0.048-0.161-0.073c-0.509-0.236-1.008-0.494-1.498-0.769c-0.086-0.049-0.171-0.098-0.257-0.148 c-0.467-0.27-0.926-0.557-1.373-0.862c-0.093-0.063-0.183-0.13-0.274-0.195c-0.414-0.292-0.819-0.596-1.214-0.918 c-0.042-0.034-0.086-0.067-0.128-0.102V38c0-6.065,4.935-11,11-11H28z M41,40.076V38c0-6.271-4.464-11.519-10.38-12.735 C33.261,23.464,35,20.431,35,17c0-5.514-4.486-10-10-10s-10,4.486-10,10c0,3.431,1.739,6.464,4.38,8.265 C13.464,26.481,9,31.729,9,38v2.076C5.284,36.135,3,30.831,3,25C3,12.869,12.869,3,25,3s22,9.869,22,22 C47,30.831,44.716,36.135,41,40.076z" />
        </svg>
      </div>
    );
  }

  return avatarContent;
};

export default Avatar;
